/*
 * @Author: alownilow alownilow@163.com
 * @Date: 2023-08-29 14:26:30
 * @LastEditors: alownilow alownilow@163.com
 * @LastEditTime: 2023-10-13 14:58:23
 * @FilePath: \alownilow-web\src\main.ts
 * @Description: 
 * alownilow@163.com
 * 
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Antd from 'ant-design-vue';

createApp(App).use(store).use(router).use(Antd).mount("#app");
